import { render, staticRenderFns } from "./Koolitused.vue?vue&type=template&id=d780b2a8&scoped=true&"
import script from "./Koolitused.vue?vue&type=script&lang=js&"
export * from "./Koolitused.vue?vue&type=script&lang=js&"
import style0 from "./Koolitused.vue?vue&type=style&index=0&id=d780b2a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d780b2a8",
  null
  
)

export default component.exports